import React from 'react';
import { PopupOrPanel } from 'components/popupsAndPanels/PopupAndPanels';

type Props = {
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const SchoolMfaWarning: React.FC<Props> = ({
  isSubmitting,
  onConfirm,
  onCancel,
}) => (
  <PopupOrPanel
    isPopup={true}
    isOpen={true}
    isSubmitting={isSubmitting}
    position="right"
    hdrTitle="Turn off MFA"
    primaryBtnTxt="I understand the risk. Turn off MFA"
    secondaryBtnTxt="Cancel"
    givenClass="ManageSchoolPopoutMenu SchoolMfaWarning"
    handleClose={onCancel}
    handlePrimaryBtn={onConfirm}
    handleSecondaryBtn={onCancel}
    width={560}
  >
    <p>
      Turning off multi-factor authentication removes an important layer of
      security, increasing the risk of unauthorised access to pupil information.
    </p>
    <p>This change will affect all users at your school.</p>
  </PopupOrPanel>
);

export default SchoolMfaWarning;
